import UtilService from "../../service/UtilService";
import { useImmer } from "use-immer";
import { useEffect, useRef } from "react";
import RuleSuppressService from "../../service/RuleSuppressService";
import { Link } from "react-router-dom";

const Component = ({
  configId,
  weightConfig,
  weightManualConfig,
  ruleSuppressGeneralConfig,
  onChange,
}) => {
  const [state, updateState] = useImmer({
    weights: weightConfig || {},
    manual: weightManualConfig || {},
  });

  const baselineRef = useRef(weightConfig || {});
  useEffect(() => {
    baselineRef.current = weightConfig || {};
  }, [configId]);

  const manualBaselineRef = useRef(weightManualConfig || {});
  useEffect(() => {
    baselineRef.current = weightConfig || {};
    manualBaselineRef.current = weightManualConfig || {};
  }, [configId]);

  useEffect(() => {
    if (!UtilService.shallowEqual(state.weights, weightConfig || {})) {
      updateState((d) => {
        d.weights = weightConfig || {};
      });
    }
  }, [weightConfig]);

  useEffect(() => {
    if (!UtilService.shallowEqual(state.manual, weightManualConfig || {})) {
      updateState((d) => {
        d.manual = weightManualConfig || {};
      });
    }
  }, [weightManualConfig]);

  const handleValueChange = (key, raw) => {
    const value = raw === "" ? "" : Number.parseFloat(raw);

    const wasManualAtLoad = Object.prototype.hasOwnProperty.call(
      manualBaselineRef.current,
      key,
    );

    const nextWeights = { ...state.weights, [key]: value };
    const nextManual = { ...state.manual };

    if (UtilService.equalish(value, baselineRef.current?.[key])) {
      if (wasManualAtLoad) {
        nextManual[key] = value;
      } else {
        delete nextManual[key];
      }
    } else {
      nextManual[key] = value;
    }

    updateState((d) => {
      d.weights = nextWeights;
      d.manual = nextManual;
    });
    onChange?.({ weightConfig: nextWeights, weightManualConfig: nextManual });
  };

  const handleManualToggle = (key, checked) => {
    let nextManual;
    if (checked) {
      nextManual = { ...state.manual, [key]: state.weights[key] };
    } else {
      const { [key]: _omit, ...rest } = state.manual;
      nextManual = rest;
    }

    updateState((d) => {
      d.manual = nextManual;
    });

    onChange?.({ weightConfig: state.weights, weightManualConfig: nextManual });
  };

  return (
    <table className="config-table">
      <thead>
        <tr>
          <th>Weight name</th>
          <th>Value</th>
          <th>Simulation type</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(state.weights).map(([key, value]) => {
          const isSuppressed = RuleSuppressService.isRuleSuppressed(
            ruleSuppressGeneralConfig,
            key,
          );
          const isManual = Object.prototype.hasOwnProperty.call(
            state.manual,
            key,
          );

          return (
            <tr key={key} className={isSuppressed ? "warn" : ""}>
              <td>
                {UtilService.camelCaseToReadable(key)}
                {isSuppressed && (
                  <Link className="float-right" to="/admin">
                    Rule suppressed
                  </Link>
                )}
              </td>
              <td>
                <input
                  type="number"
                  min="0"
                  max="10"
                  step="0.1"
                  value={value}
                  onChange={(e) => handleValueChange(key, e.target.value)}
                />
              </td>
              <td style={{ textAlign: "left" }}>
                <label
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div className="fa-align-left">
                    <input
                      type="checkbox"
                      checked={isManual}
                      onChange={(e) =>
                        handleManualToggle(key, e.target.checked)
                      }
                    />
                  </div>
                  {/*<span style={{ fontSize: 12, opacity: 0.8 }}>*/}
                  {isManual ? "manually set" : "auto-calculated"}
                  {/*</span>*/}
                </label>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Component;
